/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DisableAutoDispoInput = {
    stationId: string;
};
export type DisableAutoDispoMutationVariables = {
    input: DisableAutoDispoInput;
};
export type DisableAutoDispoMutationResponse = {
    readonly DisableAutoDispoMutation: boolean;
};
export type DisableAutoDispoMutation = {
    readonly response: DisableAutoDispoMutationResponse;
    readonly variables: DisableAutoDispoMutationVariables;
};



/*
mutation DisableAutoDispoMutation(
  $input: DisableAutoDispoInput!
) {
  DisableAutoDispoMutation(input: $input)
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "DisableAutoDispoMutation",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DisableAutoDispoMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DisableAutoDispoMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fe962348d779d25de2f91c38c83d7eb9",
    "id": null,
    "metadata": {},
    "name": "DisableAutoDispoMutation",
    "operationKind": "mutation",
    "text": "mutation DisableAutoDispoMutation(\n  $input: DisableAutoDispoInput!\n) {\n  DisableAutoDispoMutation(input: $input)\n}\n"
  }
};
})();
(node as any).hash = 'e9251088c2a7e1508c86570702215836';
export default node;
